import { type SkuId } from '@bluebrick/discounts-service-module'
import { defineStore, storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import { type CustomDepthsMap } from '@/features/eventDetails/types'
import { useEventDetailsRemoteDataStore } from '@/features/eventDetails/useEventDetailsRemoteDataStore'

/**
 * Store keeps recommended and currently set depths for all selected SKUs in current event.
 */
export const useEventDetailsDepthsStore = defineStore('eventDetailsDepths', () => {
	const { recommendedDiscountDepth } = storeToRefs(useEventDetailsRemoteDataStore())

	const customDepths = ref<CustomDepthsMap>(new Map())

	function setCustomDepth(skuId: SkuId, depth: number) {
		customDepths.value.set(skuId, depth)
	}

	function reset() {
		customDepths.value.clear()
	}

	return {
		customDepths: computed(() => customDepths.value),
		recommendedDepths: recommendedDiscountDepth,
		setCustomDepth,
		reset
	}
})
